export default {
  PLACEHOLDER: 'schedule-shift-confirm:unique:id',
};
